import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LOGO_URL } from "@/lib/company";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  const input =
    "w-full border border-[#E5E5E5] bg-white px-4 py-3 text-[#0A0A0A] outline-none transition-colors focus:border-[#0A0A0A]";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F0F0F2] px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-[#E5E5E5] bg-white p-8 lg:p-10">
        <img src={LOGO_URL} alt="Elvocom AG" className="mx-auto h-10 w-auto object-contain" />
        <div className="mt-8 flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center bg-[#0A0A0A]">
            <Lock size={18} className="text-white" />
          </span>
          <h1 className="text-2xl font-semibold tracking-tight text-[#0A0A0A]">Admin-Login</h1>
        </div>

        <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="mb-2 block text-sm font-medium text-[#0A0A0A]">E-Mail</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className={input} data-testid="login-email" />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-[#0A0A0A]">Passwort</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className={input} data-testid="login-password" />
          </div>
          {error && <p className="text-sm text-[#E8620E]" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} className="flex w-full items-center justify-center gap-2 bg-[#E8620E] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#C4520C] disabled:opacity-60" data-testid="login-submit">
            {loading ? <><Loader2 size={16} className="animate-spin" /> Anmelden ...</> : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
